Object.defineProperty(exports, "__esModule", { value: true });
var ToSet = /** @class */ (function () {
    function ToSet() {
    }
    /**
     * Returns all elements of the sequence as set. If a `set` is passed
     * the elements are added to this set.
     *
     * @param {Set<T>} set
     * @returns {Set<T>}
     */
    ToSet.prototype.toSet = function (set) {
        var result = set || new Set();
        for (var item = this.iterator.next(); !item.done; item = this.iterator.next()) {
            result.add(item.value);
        }
        return result;
    };
    return ToSet;
}());
exports.ToSet = ToSet;
//# sourceMappingURL=toSet.js.map